import React from 'react';
import { Col, Row, Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { profilePremiumSignupUrl } from 'bundles/connect/helpers/prospect_api';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  hasActiveProduct: boolean;
  label: string;
  value: string | number | boolean | null | undefined;
  restricted?: boolean;
};

export default function PropertyInfoRow({
  label,
  value,
  restricted = false,
  hasActiveProduct = false
}: Props) {
  const renderValue = () => {
    if (restricted) {
      if (hasActiveProduct) {
        return (
          <span className="badge badge-secondary badge-muted">
            <FontAwesomeIcon className="me-1" icon={faLock} />
            Locked
          </span>
        );
      } else {
        return (
          <Button
            href={profilePremiumSignupUrl}
            rel="noopener noreferrer"
            size="sm"
            target="_blank"
            variant="shaded-secondary"
          >
            <FontAwesomeIcon className="me-1" icon={faSparkles} />
            Upgrade To Access
          </Button>
        );
      }
    }

    return value;
  };

  return (
    <Row className="gx-0 border-bottom border-light align-items-center py-2">
      <Col lg={5} xs>
        <span className="fw-bold">
          {label}
        </span>
      </Col>
      <Col>{renderValue()}</Col>
    </Row>
  );
}
